module.exports = __webpack_public_path__ + "img/congenital_pic.99e2009f.png";